import { actionTypes } from "../../actions/action_types";

const initialState = {
  branch_category_list: [],
};

export default function branch_category_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_BRANCHCATEGORY_GET_OVERALL:
      stateCopy.branch_category_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_BRANCHCATEGORY_GET_CLUSTER:
      stateCopy.branch_category_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_BRANCHCATEGORY_GET_AREA:
      stateCopy.branch_category_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_BRANCHCATEGORY_GET_BRANCH:
      stateCopy.branch_category_list = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
